import React, { JSX } from 'react';

export interface MainContextType {
	pageTitle: JSX.Element;
	setTitle: (title: JSX.Element) => void;
}

export const MainContext = React.createContext<MainContextType>({
	pageTitle: <></>,
	setTitle: () => {}
});
